import * as Yup from 'yup';

import { ALLOWED_CHARACTERS_REGEX } from '@/common/constants';

export const addRoleSchema = () => {
    return (
        Yup.object({
            id: Yup.string()
                .trim()
                .required('ID is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            name: Yup.string()
                .trim()
                .required('Name is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            desc: Yup.string()
                .trim()
                .required('Description is required')
                .matches(ALLOWED_CHARACTERS_REGEX, 'Input must only contain alphabets, numbers, commas, dots, slashes, and dashes.')
                .max(50, 'Max length is 50 characters'),
            type: Yup.string()
                .trim()
                .required('Type is required')
        }));
}
